import { createContext } from 'react'

export const SearchContext = createContext<{ query: string; results: unknown[] } | null>(null)
